<template>
  <div class="mx-auto mt-[10%] flex flex-col text-center">
    <span class="text-[60px] text-[#BEF264]">check link...</span>
    <a v-if="textError !== ''" class="text-[#F87171] mb-2" href="/onboarding/login-method"> Error: {{ textError }}</a>
    <a v-if="textError !== ''" class="text-foregroundPrimary" href="/">
      <BaseButton class="max-w-[100px] sign-in-button !bg-[#18181B] !text-[#F2F2F2]">Back</BaseButton>
    </a>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { onMounted, ref, computed} from "vue";
import { useStore } from "vuex";
import { useToast } from 'primevue/usetoast';

const getIdPostVisitLink = (id) => store.dispatch("checkVisitLink", id);
const getProfile = (id) => store.dispatch("setProfile", id);
const userdata = computed(() => store.getters.getProfile);
const store = useStore();
const router = useRouter();
const textError = ref('');

onMounted(async() => {
  let response = await getIdPostVisitLink(router.currentRoute.value.params.id);
  await getProfile(response.userId);
  if(response.statusCode) {
    textError.value = response.error;
  } else {
    if(response.postId) {
      router.push(`/post/${response.postId}`)
    } else {
      router.push(`/user/${userdata.value.username}`)
    }
  }
})
</script>